import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Joi from 'joi';
import pluralize from 'pluralize';
import moment from 'moment';
import Konami from 'react-konami';
import JSONPretty from 'react-json-pretty';
import JSONPrettyMon from 'react-json-pretty/dist/monikai';
import { Modal, Button, HelpBlock, Tabs, Tab, FormControl, OverlayTrigger, Popover, Tooltip } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Field, reduxForm, formValueSelector, SubmissionError } from 'redux-form';
import {
  delay, omit, filter, find, findLast,
} from 'lodash';
import Pusher from '../../../../components/pusher';
import ProgressBar from '../../../../components/progress-bar';
import OpportunitySelector from '../../../../components/opportunity-selector';
import AccountSelector from '../../../../components/account-selector';
import UserSelector from '../../../../components/user-selector';
import { testDiscoveryBotStatus, getTestDiscoveryBotStatusResults } from '../../SetupActions';
import { getUserCurrentOrganization, getUser } from '../../../Auth/AuthReducer';
import AnimatedText from '../../../../components/animated-text';
import SearchForm from '../../../../components/search-form';
import { cleanSubmitCriteria } from '../../../../components/search-form/search-form-reducer';
import BooleanField from '../../../../components/search-form/boolean-field';
import OpportunityNameRenderer from '../../../../components/table-cells/OpportunityNameRenderer';
import AccountNameRenderer from '../../../../components/table-cells/AccountNameRenderer';
import OwnerNameRender from '../../../../components/table-cells/SaleRepsNameRenderer';
import CopyButton from '../../../../components/copy-button';
import AccountOpportunitiesList from './AccountOpportunityList';
import ContactList from './ContactList';
import PathDisplay from '../../../../components/search-path/path';
import CheckConnection from '../../../../components/pusher/check-connection';

import styles from './styles.css';

const FORM_NAME = 'automationTestForm';
const TAB_RESULTS = 'results';
const TAB_DETAILS = 'details';
const TAB_CURL = 'curl';
const TAB_LOGS = 'logs';
const TAB_REQUESTS = 'requests';
const TAB_CONTACTS = 'contacts';

const SHOW_OWNER_SELECTOR = false;

class TestModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loaded: false,
      error: null,
      results: null,
      logs: [],
      requestedLogs: [],
      matchedContacts: [],
      selectedTab: TAB_RESULTS,
      copied: false,
      copiedCurl: false,
      copiedLogs: false,
      copiedRequestedLogs: false,
      curlData: null,
      logData: null,
      requestedLogData: null,
      resultData: null,
      params: props.settings,
      dynamicSenders: [],
      socketId: null,
      socketConnected: false,
      debug: false,
    };
    this.close = this.close.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleOpportunitySelected = this.handleOpportunitySelected.bind(this);
    this.handleAccountSelected = this.handleAccountSelected.bind(this);
    this.handleUserSelected = this.handleUserSelected.bind(this);
    this.closeDate = moment().startOf('day').subtract(90, 'days').format('YYYY-MM-DD');
    this.renderField = this.renderField.bind(this);
    this.redoTest = this.redoTest.bind(this);
    this.fixError = this.fixError.bind(this);
    this.handleTabSelect = this.handleTabSelect.bind(this);
    this.onCopy = this.onCopy.bind(this);
    this.onCopyCurl = this.onCopyCurl.bind(this);
    this.onCopyLogs = this.onCopyLogs.bind(this);
    this.onCopyRequestedLogs = this.onCopyRequestedLogs.bind(this);
    this.onSocketCallback = this.onSocketCallback.bind(this);
    this.onSocketConnectedHandler = this.onSocketConnectedHandler.bind(this);
    this.toggleDebug = this.toggleDebug.bind(this);
    this.handleDebugMessage = this.handleDebugMessage.bind(this);
  }

  onCopy() {
    this.setState({ copied: true }, () => {
      delay(() => {
        this.setState({ copied: false });
      }, 2000);
    });
  }

  toggleDebug() {
    alert('a')
    this.setState({ debug: !this.state.debug });
  }

  handleDebugMessage(id, params) {
    console.log('');
    console.log('id', id);
    console.log('params', params);
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open && this.state.socketConnected) {
      this.loadData();
    }
  }

  loadData() {
    const { ownerId, opportunityId, accountId, automationId } = this.props;
    if (opportunityId && ownerId) {
      this.doSubmit({
        opportunity_id: opportunityId,
        sender_id: ownerId,
      }, automationId);
    } else if (accountId && ownerId) {
      this.doSubmit({
        account_id: accountId,
        sender_id: ownerId,
      }, automationId);
    }
  }

  onCopyCurl() {
    this.setState({ copiedCurl: true }, () => {
      delay(() => {
        this.setState({ copiedCurl: false });
      }, 2000);
    });
  }

  onCopyLogs() {
    this.setState({ copiedLogs: true }, () => {
      delay(() => {
        this.setState({ copiedLogs: false });
      }, 2000);
    });
  }

  onCopyRequestedLogs() {
    this.setState({ copiedRequestedLogs: true }, () => {
      delay(() => {
        this.setState({ copiedRequestedLogs: false });
      }, 2000);
    });
  }

  onSocketConnectedHandler() {
    this.setState({ socketConnected: true }, () => {
      this.loadData();
    });
  }
  
  onSocketCallback(e) {
    if (e.id === this.state.socketId) {
      if (e.isError) {
        this.setState({
          loading: false,
          loaded: false,
          error: e.message,
          logs: [],
          requestedLogs: [],
          selectedTab: TAB_RESULTS,
        });
      } else {
        this.props.dispatch(getTestDiscoveryBotStatusResults(this.props.organization._id, e.id))
          .then(
            (results) => {
              const r = this.handlResults(results);
              this.setState({
                socketId: null,
                loading: false,
                loaded: true,
                selectedTab: TAB_DETAILS,
                ...r,
              });
            },
            (er) => {
              this.setState({
                loading: false,
                loaded: false,
                error: er.message,
                logs: [],
                selectedTab: TAB_RESULTS,
              });
            },
          );
      }
    }
  }

  close() {
    this.props.onClose();
    delay(() => {
      this.setState({
        loading: false, loaded: false, error: null, results: null,
        selectedTab: TAB_RESULTS, socketId: null,
      });
      this.handleUserSelected(null);
    }, 500);
  }

  handleOpportunitySelected(opportunityId) {
    this.props.change('opportunity_id', opportunityId);
    this.props.touch('opportunity_id');
  }

  handleAccountSelected(accountId) {
    this.props.change('account_id', accountId);
    this.props.touch('account_id');
  }

  handleTabSelect(selectedTab) {
    this.setState({ selectedTab });
  }

  handleUserSelected(userId) {
    this.props.change('sender_id', userId);
    this.props.touch('sender_id');
    if (userId === null) {
      if (this.props.isAccount) {
        this.props.change('account_id', null);
        this.props.touch('account_id');
      } else {
        this.props.change('opportunity_id', null);
        this.props.touch('opportunity_id');  
      }
    }
  }

  handlResults(results) {
    let curlData = null;
    let resultData = null;

    if (results && results.results) {
      curlData = results.results.curlData || '';
      delete results.results.curlData;
    }
    resultData = JSON.stringify(results, null, 4);
    const matchedContacts = filter(results.contacts, { valid: true });
    return {
      results,
      curlData,
      // selectedTab: TAB_DETAILS,
      resultData,
      dynamicSenders: results.dynamicSenders,
      matchedContacts,
    };
  }

  doSubmit(params, automationId = null) {
    this.setState({
      loading: true, loaded: false, error: null, 
      results: null, logs: [], selectedTab: TAB_RESULTS,
      params: params.settings,
      socketId: null,
      dynamicSenders: [],
    });
    this.props.dispatch(testDiscoveryBotStatus(this.props.organization._id, params, automationId, this.state.debug))
      .then(
        (results) => {
          let logs = [];
          let logData = null;
          if (results && results.logs) {
            logs = results.logs || [];
          }
          logData = JSON.stringify(logs, null, 4);
          
          let requestedLogs = [];
          let requestedLogData = null;
          if (results && results.requestedLogs) {
            requestedLogs = results.requestedLogs || [];
          }
          requestedLogData = JSON.stringify(requestedLogs, null, 4);
          

          if (results.id) {
            // socket
            this.setState({ logs, logData, requestedLogs, requestedLogData, socketId: results.id });
          } else {
            const r = this.handlResults(results);
            this.setState({
              socketId: null,
              loading: false,
              loaded: true,
              logs,
              logData,
              requestedLogs,
              requestedLogData,
              selectedTab: TAB_DETAILS,
              ...r,
            });
          }
        },
        (error) => {
          this.setState({ loading: false, loaded: false, error: error.data || error, logs: [], selectedTab: TAB_RESULTS });
          throw new SubmissionError(error.data || error);
        },
      );
  }

  handleSubmit(data) {
    if (this.state.loading) {
      throw new SubmissionError({ message: 'Loading' });
    }
    const params = {
      ...data,
      settings: {
        ...omit(this.props.settings, ['all_contact_roles', 'all_contact_reference_fields', 'search_query', 'open_window_search_query', 'full_automation_contact_query']),
        search_query: cleanSubmitCriteria(this.props.searchQuery),
        open_window_search_query: cleanSubmitCriteria(this.props.openWindowSearchQuery),
        full_automation_contact_query: cleanSubmitCriteria(this.props.contactQuery),
      },
    };
    this.doSubmit(params);
  }

  redoTest() {
    this.setState({
      loading: false, loaded: false, error: null, results: null, selectedTab: TAB_RESULTS,
    });
    this.handleUserSelected(null);
  }

  fixError() {
    this.setState({
      loading: false, loaded: false, error: null, results: null, selectedTab: TAB_RESULTS,
    });
  }

  renderField({
    input, label, type,
  }) {
    return (
      <FormControl className="hidden" {...input} placeholder={label} type={type} disabled />
    );
  }

  renderForm() {
    const {
      handleSubmit, selectedSenderId,
      submitting, invalid, isAccount,
    } = this.props;
    
    const resource = isAccount ? 'account' : 'opportunity';

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Modal.Body>
          {this.state.debug && <div className="alert alert-warning">Dbug mode enabled</div>}
          <div className="well">
            {SHOW_OWNER_SELECTOR &&
              <p>
                Select the {resource} owner and {resource} you want to test and click the <strong>Run Test</strong> button to see the test results.
              </p>
            }
            {!SHOW_OWNER_SELECTOR &&
              <p>
                Select the {resource} you want to test and click the <strong>Run Test</strong> button to see the test results.
              </p>
            }
          </div>

          {SHOW_OWNER_SELECTOR &&
            <div>
              <Field name="sender_id" type="text" component={this.renderField} />
                <UserSelector
                  onSelect={this.handleUserSelected}
                  query={{ isStandardUser: true }}
                />
                <HelpBlock>
                  Use Salesforce User ID to test an owner that does not show in the selector.
                </HelpBlock>

                <p>&nbsp;</p>
            </div>
          }
          {!this.props.isAccount &&
            <div>
              <Field name="opportunity_id" type="text" component={this.renderField} />
              <OpportunitySelector
                key={(selectedSenderId || 'new')}
                onSelect={this.handleOpportunitySelected}
                disabled={(SHOW_OWNER_SELECTOR && selectedSenderId === null)}
                query={{ is_closed: true, start_date: this.closeDate, ...(SHOW_OWNER_SELECTOR ? { owner_id: selectedSenderId } : {}) }}
              />
            </div>
          }
          {this.props.isAccount &&
            <div>
              <Field name="account_id" type="text" component={this.renderField} />
              <AccountSelector
                key={(selectedSenderId || 'new')}
                onSelect={this.handleAccountSelected}
                disabled={(SHOW_OWNER_SELECTOR && selectedSenderId === null)}
                query={{ is_closed: true, start_date: this.closeDate, ...(SHOW_OWNER_SELECTOR ? { owner_id: selectedSenderId } : {}) }}
              />
            </div>
          }
          <HelpBlock>
            * Note: Only {isAccount ? 'accounts with' : ''} <strong>closed opportunities</strong> for the <strong>past 90</strong> days are shown in the {resource} selector. Use Salesforce {resource} ID to test an {resource} that does not show in the selector.
          </HelpBlock>
        </Modal.Body>
        <Modal.Footer>
          <Button disabled={submitting || invalid} key="button" type="submit" bsStyle="primary">
            Run Test <Fa name="chevron-right" />
          </Button>
        </Modal.Footer>
      </form>
    );
  }

  renderLoading() {
    const { socketId } = this.state;
    return (
      <div>
        <Modal.Body>
          <AnimatedText text="Syncing Salesforce Information" />
          <p />
          <p>
            Testing {this.props.isAccount ? 'account' : 'opportunity'} trigger conditions, contact submit conditions, product conditions, email conditions and survey collector conditions takes a little time... We will have your results shortly!
          </p>
          <p />
          <ProgressBar />
          <p />
          {socketId !== null && <Pusher key={socketId} event={socketId} handler={this.onSocketCallback} />}
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="default" onClick={this.close}>
            Cancel
          </Button>
        </Modal.Footer>
      </div>
    );
  }

  renderFooter(hasError = false) {
    const { opportunityId, isAccount, accountId } = this.props;
    return (
      <Modal.Footer>
        <div className="clearfix">
          {((opportunityId === null && !isAccount) || accountId === null && isAccount) &&
            <Button className="pull-left" bsStyle="primary" onClick={hasError ? this.fixError : this.redoTest}>
              <Fa name="chevron-left" /> Run Another Test
            </Button>
          }
          <Button className="pull-right" bsStyle="default" onClick={this.close}>
            Done
          </Button>
        </div>
      </Modal.Footer>
    );
  }

  renderSCErrors(pass, remainingContacts, tvErrors, errors) {
    if (remainingContacts > 0) {
      // return null;
    }
    if (remainingContacts === 0 && (!tvErrors || tvErrors.length === 0) && (!errors || errors.length === 0)) {
      return (
        <span className="text-danger">
          No valid contacts found.
        </span>
      );
    }

    if (pass && (tvErrors.length === 0 && errors.length === 0)) {
      return null;
    }
    
    if (remainingContacts === 0 && errors.length > 0) {
      return (
        <div className="text-danger">
          <ul>
            {errors.map((m, i) => {
              return (
                <li key={i}>{m}</li>
              );
            })}
          </ul>
        </div>
      );
    }



    const errMsg = filter(tvErrors, (e) => {
      return e !== '';
    });

    if (errMsg.length === 0 && remainingContacts === 0) {
      return (
        <span className="text-danger">
          Survey collector settings prevent submission.
        </span>
      )
    }

    return (
      <div className="text-danger">
        <ul>
          {errMsg.map((m, i) => {
            return (
              <li key={i}>{m}</li>
            );
          })}
        </ul>
      </div>
    );



    /*
    let errMsg = filter(tvErrors, (e) => {
      return e !== '';
    }).join('. ');
  
    const tip = (
      <Tooltip id="add-contact-tip">
        <div>{tvErrors.join('. ')}</div>
      </Tooltip>
    );
    if (errMsg === '') {
      errMsg = 'Survey collector settings prevent submission.';
    } else {
      errMsg = (
        <span>
          {errMsg}. Survey collector settings prevent submission. <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={tip}><Fa name="exclamation-triangle" className="text-danger" /></OverlayTrigger>
        </span>
      );
    }
  
    return (
      <span className="text-danger">
        {errMsg} 
      </span>
    );
    */
  }

  renderDynamicSenders() {
    const { isAccount } = this.props;
    const { dynamicSenders } = this.state;
    if (!dynamicSenders || dynamicSenders.length === 0) {
      return null;
    }
    const qualifiedSender = find(dynamicSenders, { isQualified: true });
    const hasQualifiedSender = qualifiedSender !== null && qualifiedSender !== undefined;
    const unqualifiedSender = findLast(dynamicSenders, { isQualified: false });

    const senderInfo = hasQualifiedSender ? qualifiedSender : unqualifiedSender;


    const note = (<div className="text-danger">No valid sender found</div>);

    if (!senderInfo || !senderInfo.sender) {
      // we don't have the info
      return note;
    }

    const signatureStatus = senderInfo.sender.signature_status;


    return (
      <div>
        <OwnerNameRender isOwner value={`${senderInfo.sender.first_name} ${senderInfo.sender.last_name}`} data={senderInfo.sender} />
        <div className="clearfix">
          <div className="pull-left">
            From field:&nbsp;
          </div>
          <div className="pull-left">
            <PathDisplay startingNode={isAccount ? 'Account' : 'Opportunity'} paths={senderInfo.field} />
          </div>
        </div>

        {signatureStatus !== null && signatureStatus !== undefined &&
          <div className="clearfix">
            <div className="pull-left">
              Sender Signature:&nbsp;
            </div>
            <div className="pull-left">
              <code className={senderInfo.sender.signature_verified ? 'text-success' : 'text-danger'}>{signatureStatus}</code>
            </div>
          </div>
        }


        {!hasQualifiedSender && senderInfo.remark !== null &&
          <div className="clearfix">
            <div className="pull-left">
              Remark:&nbsp;
            </div>
            <div className="pull-left text-danger">
              {senderInfo.remark}
            </div>
          </div>
        }



      </div>
    );
  }

  renderOpportunityDetail(opportunity, owner, account) {
    const { isAccount } = this.props;
    const { results, dynamicSenders } = this.state;
    const opportunityName = (<OpportunityNameRenderer value={opportunity.name} data={opportunity} />);
    const ownerName = (<OwnerNameRender isOwner value={`${owner.first_name} ${owner.last_name}`} data={owner} />);
    const accountName = <AccountNameRenderer value={account.name} data={account} />;
    
    const ret = results ? results.results : {};

    const productConditions = !ret.requireTVProducts || (ret.requireTVProducts && ret.hasTVProducts);

    // https://github.com/lumen-software/TruSales/issues/1698
    let previouslySubmitted = null;
    if (ret.previousSubmittedContacts > 0) {
      const tip = (
        <Tooltip id="previous-submitted-contacts">
          <div>{ret.previousSubmittedContacts} {pluralize('contact', ret.previousSubmittedContacts)} previously submitted</div>
        </Tooltip>
      );
      previouslySubmitted = (
        <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={tip}><Fa name="exclamation-triangle" className="text-warning" /></OverlayTrigger>
      );
    }

    let ownerIsCommunicationRecipient = null;
    if (ret.ownerIsCommunicationRecipient) {
      const communicationTip = (
        <Tooltip id="communication-recipient">
          <div>Is a communication recipient</div>
        </Tooltip>
      );
      ownerIsCommunicationRecipient = (
        <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={communicationTip}><Fa name="exclamation-triangle" className="text-warning" /></OverlayTrigger>
      );
    }

    return (
      <div>
        <table className="table table-condensed table-striped">
          <tbody>
            {ret.automationName && ret.automationId &&
              <tr>
                <th>Automation:</th>
                <td colSpan={2}>{ret.automationName}</td>
              </tr>
            }
            {!isAccount &&
              <tr>
                <th>Opportunity:</th>
                <td>{opportunityName}</td>
                <td className="text-right">
                  <div>
                    <CopyButton data={opportunity.opportunity_id} key={opportunity.opportunity_id} tooltip="Copy Opportunity ID">
                      <Fa name="copy" /> Copy Id
                    </CopyButton>
                  </div>
                </td>
              </tr>
            }
            <tr>
              <th>Owner:</th>
              <td>
                {ownerName} {ownerIsCommunicationRecipient}
              </td>
              <td className="text-right">
                <div>
                  <CopyButton data={opportunity.owner_id} key={opportunity.owner_id} tooltip="Copy Owner ID">
                    <Fa name="copy" /> Copy Id
                  </CopyButton>
                </div>
              </td>
            </tr>
            <tr>
              <th>Account:</th>
              <td>{accountName}</td>
              <td className="text-right">
                <div>
                  <CopyButton data={opportunity.account_id} key={opportunity.account_id} tooltip="Copy Account ID">
                    <Fa name="copy" /> Copy Id
                  </CopyButton>
                </div>
              </td>
            </tr>

            <tr>
              <th>Automation Trigger Conditions:</th>
              <td colSpan="2"><span className={`label ${(ret.isQualified ? 'label-success' : 'label-danger animated flash')}`}>{(ret.isQualified ? 'Passed' : 'Failed')}</span></td>
            </tr>

            <tr>
              <th>Qualified Contact(s) Identified:</th>
              <td colSpan="2">
                <span className={`label ${(ret.remainingContacts > 0 ? 'label-success' : 'label-danger animated flash')}`}>{(ret.remainingContacts > 0 ? 'Passed' : 'Failed')}</span> {previouslySubmitted}
              </td>
            </tr>

            <tr>
              <th>Survey Collector Settings:</th>
              <td colSpan="2"><span className={`label ${((ret.canSubmitAtLeastOneContact && ret.tvContactErrors?.length === 0) ? 'label-success' : 'label-danger animated flash')}`}>{(ret.canSubmitAtLeastOneContact && ret.tvContactErrors?.length === 0 ? 'Passed' : 'Failed')}</span> {this.renderSCErrors(ret.canSubmitAtLeastOneContact, ret.remainingContacts, ret.tvContactErrors, ret.contactErrors)}</td>
            </tr>



            <tr>
              <th>Product Conditions:</th>
              <td colSpan="2"><span className={`label ${(productConditions ? 'label-success' : 'label-danger animated flash')}`}>{(productConditions ? 'Passed' : 'Failed')}</span></td>
            </tr>

            <tr>
              <th>Owner Is Active:</th>
              <td colSpan="2"><span className={`label ${(ret.senderIsActive ? 'label-success' : 'label-danger animated flash')}`}>{(ret.senderIsActive ? 'Passed' : 'Failed')}</span></td>
            </tr>

            {dynamicSenders && dynamicSenders.length > 0 &&
              <tr>
                <th>Dynamic Sender:</th>
                <td colSpan="2">
                  {this.renderDynamicSenders()}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    );
  }

  renderAccountOpportunitiesResults() {
    const { results, params } = this.state;
    return (
      <div>
        <AccountOpportunitiesList
          account={results.account}
          opportunities={results.opportunities}
          settings={params}
          automationId={this.props.automationId}
        />
      </div>
    );
  }
  
  renderResults() {
    const {
      results, copied, selectedTab, copiedCurl, copiedLogs, logs,
      curlData, resultData, logData, params, matchedContacts,
      requestedLogs, copiedRequestedLogs,
    } = this.state;
    const { showCurlTab, isAccount } = this.props;
    let remark = null;
    if (results.results && results.results.remark && results.results.remark.length > 0) {
      ({ remark } = results.results);
    }
    if (!remark) {
      const isExcluded = results && results.results && results.results.isExcluded;
      const excludedReason = results && results.results && results.results.excludedReason;
      if (isExcluded) {
        remark = 'This opportunity was excluded';
      }
      if (excludedReason) {
        remark = `${remark}. Reason: ${excludedReason}`;
      }
    }


    return (
      <div>
        <Modal.Body>
          {remark !== null && <div className="alert alert-danger">{remark}</div>}
          {this.renderOpportunityDetail(results.opportunity, results.owner, results.account)}
          <Tabs
            activeKey={selectedTab}
            onSelect={this.handleTabSelect}
            id="test-result-tabs"
          >
            <Tab
              eventKey={TAB_DETAILS}
              title={isAccount ? 'Account' : 'Opportunity'}
            >
              <div>
                <p />
                {results.queryExplanation === null &&
                  <div className="alert alert-warning">
                    Trigger conditions explanations are not available at this time. Please try again later.
                  </div>
                }
                {results.queryExplanation !== null &&
                  <SearchForm
                    onSearchChange={() => {}}
                    disabled
                    readOnly
                    standalone
                    simpleMode
                    defaultCriteria={isAccount ? null : results.queryExplanation}
                    type="automations/test-discovery-bot"
                  >
                    <div key="owner-connected">
                      <BooleanField
                        path={[]}
                        level={1}
                        showDelete={false}
                        showInclude={false}
                        disabled
                        editable
                        readOnly
                        searchCriteria={{
                          _id: 'owner-connected',
                          type: 'include',
                          results: results.results.senderIsConnected || !results.results.requireSenderConnected,
                          values: [results.results.senderIsConnected || !results.results.requireSenderConnected],
                          filter: {
                            _id: 'owner-connected-filter',
                            label: 'Owner Connected',
                          },
                        }}
                        onUpdate={() => {}}
                      />
                    </div>
                    <div key="space-1">&nbsp;</div>
                    <div key="owner-enabled">
                      <BooleanField
                        path={[]}
                        level={1}
                        showDelete={false}
                        showInclude={false}
                        disabled
                        editable
                        readOnly
                        searchCriteria={{
                          _id: 'owner-enabled',
                          type: 'include',
                          results: results.results.senderIsEnabled,
                          values: [results.results.senderIsEnabled],
                          filter: {
                            _id: 'owner-enabled-filter',
                            label: 'Owner Enabled',
                          },
                        }}
                        onUpdate={() => {}}
                      />
                    </div>
                    {isAccount && <div key="space-2">&nbsp;</div>}
                    {isAccount && this.renderAccountOpportunitiesResults()}
                  </SearchForm>
                }
              </div>
            </Tab>

            <Tab
              eventKey={TAB_CONTACTS}
              title="Contacts"
            >
              <div>
                <p />
                <ContactList
                  isAccount={isAccount}
                  contacts={results.contacts}
                  totalMatched={matchedContacts.length}
                  settings={params}
                  automationId={this.props.automationId}
                  owner={results.owner}
                  account={results.account}
                  opportunity={results.opportunity}
                />
              </div>
            </Tab>

            <Tab
              eventKey={TAB_RESULTS}
              title="Results"
            >
              <div>
                <p />
                <div className={styles.codeWrapper}>
                  <div className={styles.codeControl}>
                    {!copied &&
                      <CopyToClipboard
                        text={resultData}
                        onCopy={this.onCopy}
                      >
                        <Button bsStyle="default"><Fa name="copy" /> Copy</Button>
                      </CopyToClipboard>
                    }
                    {copied && <Button bsStyle="default" className="animated flash" disabled><Fa name="copy" /> Copied!</Button>}
                  </div>
                  <div className={styles.code}>
                    <JSONPretty style={{ margin: 0 }} data={results.results} theme={JSONPrettyMon} />
                  </div>
                </div>
              </div>
            </Tab>
            {showCurlTab &&
              <Tab
                eventKey={TAB_CURL}
                title="API Call"
              >
                <div>
                  <p />
                  <div className={styles.codeWrapper}>
                    <div className={styles.codeControl}>
                      {!copiedCurl &&
                        <CopyToClipboard
                          text={curlData}
                          onCopy={this.onCopyCurl}
                        >
                          <Button bsStyle="default"><Fa name="copy" /> Copy</Button>
                        </CopyToClipboard>
                      }
                      {copiedCurl && <Button bsStyle="default" className="animated flash" disabled><Fa name="copy" /> Copied!</Button>}
                    </div>
                    <div className={styles.code}>
                      <JSONPretty style={{ margin: 0 }} data={curlData} theme={JSONPrettyMon} />
                    </div>
                  </div>
                </div>
              </Tab>
            }
            {logs && logs.length > 0 &&
              <Tab
                eventKey={TAB_LOGS}
                title="Logs"
              >
                <div>
                  <p />
                  <div className={styles.codeWrapper}>
                    <div className={styles.codeControl}>
                      {!copiedLogs &&
                        <CopyToClipboard
                          text={logData}
                          onCopy={this.onCopyLogs}
                        >
                          <Button bsStyle="default"><Fa name="copy" /> Copy</Button>
                        </CopyToClipboard>
                      }
                      {copiedLogs && <Button bsStyle="default" className="animated flash" disabled><Fa name="copy" /> Copied!</Button>}
                    </div>
                    <div className={styles.code} style={{ maxHeight: '400px', overFlowY: 'auto' }}>
                      <JSONPretty style={{ margin: 0 }} data={logs} theme={JSONPrettyMon} />
                    </div>
                  </div>
                </div>
              </Tab>
            }



            {requestedLogs && requestedLogs.length > 0 &&
              <Tab
                eventKey={TAB_REQUESTS}
                title="Requested Logs"
              >
                <div>
                  <p />
                  <div className={styles.codeWrapper}>
                    <div className={styles.codeControl}>
                      {!copiedRequestedLogs &&
                        <CopyToClipboard
                          text={logData}
                          onCopy={this.onCopyRequestedLogs}
                        >
                          <Button bsStyle="default"><Fa name="copy" /> Copy</Button>
                        </CopyToClipboard>
                      }
                      {copiedRequestedLogs && <Button bsStyle="default" className="animated flash" disabled><Fa name="copy" /> Copied!</Button>}
                    </div>
                    <div className={styles.code} style={{ maxHeight: '400px', overFlowY: 'auto' }}>
                      <JSONPretty style={{ margin: 0 }} data={requestedLogs} theme={JSONPrettyMon} />
                    </div>
                  </div>
                </div>
              </Tab>
            }
          </Tabs>
        </Modal.Body>
        {this.renderFooter()}
      </div>
    );
  }

  renderError() {
    const { error } = this.state;
    return (
      <div>
        <Modal.Body>
          <div className="alert alert-danger">
            <Fa name="exclamation-triangle" /> An error occurred. Please try again.
          </div>
          <div className={styles.code}>
            <JSONPretty style={{ margin: 0 }} data={error} theme={JSONPrettyMon} />
          </div>
        </Modal.Body>
        {this.renderFooter(true)}
      </div>
    );
  }


  renderModal() {
    const { loading, loaded, error, socketConnected } = this.state;
    let content = null;
    
    if (socketConnected) {
      if (loading) {
        content = this.renderLoading();
      } else if (!loading && loaded) {
        content = this.renderResults();
      } else if (!loading && !loaded && error !== null) {
        content = this.renderError();
      } else {
        content = this.renderForm();
      }  
    }
    
    return (
      <Modal key="test-modal" show={this.props.open} bsSize="lg" onHide={this.close} keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Automation Trigger Condition Testing {loaded ? 'Results' : ''}</Modal.Title>
        </Modal.Header>
        {socketConnected && content}
        {!socketConnected &&
          <Modal.Body>
            <CheckConnection onConnected={this.onSocketConnectedHandler} />
          </Modal.Body>
        }
        <Konami easterEgg={this.toggleDebug} />
        <Pusher event="automation-test-debug" handler={this.handleDebugMessage} />

      </Modal>
    );
  }

  render() {
    return this.renderModal();
  }
}

const selector = formValueSelector(FORM_NAME);

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    showCurlTab: getUser(state).role === 'superadmin',
    organization: getUserCurrentOrganization(state),
    selectedSenderId: selector(state, 'sender_id'),
  };
}

TestModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  showCurlTab: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  // error: PropTypes.string,
  reset: PropTypes.func.isRequired,
  selectedSenderId: PropTypes.string,
  invalid: PropTypes.bool.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  touch: PropTypes.func.isRequired,
  settings: PropTypes.shape({
    api_key: PropTypes.string,
  }).isRequired,
  organization: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
  searchQuery: PropTypes.shape({}),
  openWindowSearchQuery: PropTypes.shape({}),
  contactQuery: PropTypes.shape({}),
  opportunityId: PropTypes.string,
  accountId: PropTypes.string,
  ownerId: PropTypes.string,
  automationId: PropTypes.string,
  isAccount: PropTypes.bool,
};
TestModal.defaultProps = {
  // error: null,
  selectedSenderId: null,
  open: false,
  onClose: () => {},
  searchQuery: {},
  openWindowSearchQuery: {},
  contactQuery: {},
  opportunityId: null,
  accountId: null,
  ownerId: null,
  automationId: null,
  isAccount: false,
};
const validate = (data) => {
  // Legacy constraints for reference:
  // const constraints = {
  //   opportunity_id: {
  //     presence: true,
  //   },
  //   sender_id: {
  //     presence: true,
  //   },
  // };

  const schema = Joi.object({
    opportunity_id: Joi.string().required().messages({
      'string.base': 'Opportunity is required',
      'string.empty': 'Opportunity is required',
      'any.required': 'Opportunity is required',
    }),
    sender_id: Joi.string().required().messages({
      'string.base': 'Sender is required',
      'string.empty': 'Sender is required',
      'any.required': 'Sender is required',
    }),
  }).unknown(true);

  const { error } = schema.validate(data, { abortEarly: false });
  if (!error) return {};
  
  return error.details.reduce((acc, curr) => {
    if (!acc[curr.path[0]]) acc[curr.path[0]] = [];
    acc[curr.path[0]].push(curr.message);
    return acc;
  }, {});
};

const TestModalForm = reduxForm({
  form: FORM_NAME,
  validate,
})(TestModal);

export default connect(mapStateToProps)(TestModalForm);
